<template>
  <div>
    <el-card>
      <el-form :inline="true" label-width="120px" size="small">
        <el-row>
          <el-col>
            <el-form-item label="标题">
              <el-input placeholder="请输入标题" v-model="title"></el-input>
            </el-form-item>
            <el-button
              style="margin-left: 15px"
              type="primary"
              size="mini"
              @click="search"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card style="margin-top: 15px">
      <a-tabs type="card" v-model="activeKey">
        <a-tab-pane v-for="(item, index) in type" :key="index">
          <span slot="tab">
            <span @click="changeType(item, index)" style="marginleft: 10px">{{
              item.name
            }}</span>
          </span>
          <el-table
            :data="list"
            :header-cell-style="getRowClass"
            border
            ref="multipleTable"
            style="width: 100%; flex: auto"
            tooltip-effect="light"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              prop="title"
              label="标题"
              align="center"
              width="600"
            ></el-table-column>

            <el-table-column
              align="center"
              class-name="small-padding fixed-width"
              label="操作"
              fixed="right"
            >
              <template slot-scope="{ row }">
                <div class="done">
                  <el-button
                    size="mini"
                    style="width: 90px; margin: 0 0 10px 10px"
                    type="primary"
                    @click="add(row)"
                    >添加</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-row style="width: auto; marginright: 50px; margintop: 20px">
            <el-pagination
              :current-page="currentPage"
              :page-size="pagesize"
              :page-sizes="[5, 10, 15]"
              :total="totalCount"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
            ></el-pagination>
          </el-row>
        </a-tab-pane>
      </a-tabs>
    </el-card>

    <a-modal
      v-model="visible"
      title="添加"
      ok-text="确认"
      cancel-text="取消"
      @ok="hideModal"
    >
      <el-form>
        <el-row v-if="this.$route.query.obj.needCoverImg == 1">
          <span style="float: left"
            >封面图({{ this.$route.query.obj.coverImgSize }})</span
          >
          <!-- <el-form-item :label="['封面图'+this.$route.query.obj.coverImgSize]" prop="coverUrl" ref="coverUrl"> -->
          <el-upload
            class="avatar-uploader"
            :action="serverUrl"
            :headers="header"
            name="img"
            :auto-upload="true"
            :show-file-list="false"
            :on-success="upSuccess"
          >
            <img
              v-if="coverImg"
              :src="coverImg"
              class="avatar"
              style="width: 150px; height: auto"
            />

            <i
              :class="
                loadUpt
                  ? 'el-icon-loading'
                  : 'el-icon-plus avatar-uploader-icon'
              "
              style="margintop: 10px; font-size: 50px"
              v-else
            ></i>
          </el-upload>
          <!-- </el-form-item> -->
        </el-row>
        <el-row style="margin-top: 30px">
          <el-form-item label="信息流位置 ">
            <el-select placeholder="请选择" v-model="rank" clearable>
              <el-option
                v-for="item in rankItem"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
    </a-modal>
  </div>
</template>
<script>
import { baseURL } from "../../api/config";
export default {
  props: ["AddData"],
  data() {
    return {
      activeKey: 0,
      loadUpt: false,
      list: [],
      checked1: false,
      pagesize: 10, //每页的个数
      currentPage: 1, //初始页
      totalCount: 0, //分页数量展示，
      current: 0,
      title: "",
      contentType: 1,
      rank: "",
      type: [
        {
          name: "新闻",
          contentType: "1",
        },
        {
          name: "音频",
          contentType: "4",
        },
        {
          name: "视频",
          contentType: "5",
        },
        {
          name: "专题",
          contentType: "6",
        },
        {
          name: "投票",
          contentType: "9",
        },
        {
          name: "问卷",
          contentType: "10",
        },
        {
          name: "召集令",
          contentType: "11",
        },
        {
          name: "新房",
          contentType: "12",
        },
        {
          name: "广告",
          contentType: "14",
        },
      ],
      rankItem: [
        {
          value: "1",
          label: "第一轮播位",
        },
        {
          value: "2",
          label: "第二轮播位",
        },
        {
          value: "3",
          label: "第三轮播位",
        },
        {
          value: "4",
          label: "第四轮播位",
        },
        {
          value: "5",
          label: "第五轮播位",
        },
        {
          value: "6",
          label: "第六轮播位",
        },
        {
          value: "7",
          label: "第七轮播位",
        },
        {
          value: "8",
          label: "第八轮播位",
        },
        {
          value: "9",
          label: "第九轮播位",
        },
        {
          value: "10",
          label: "第十轮播位",
        },
      ],
      coverImg: "",
      addList: [],
      location: "",
      visible: false,
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
    };
  },
  methods: {
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    getList() {
      this.postAxios("/rotation/listAllContentByType", {
        page: {
          pageNum: this.currentPage,
          pageSize: 10,
        },
        q: {
          contentType: this.contentType,
          title: this.title,
        },
      }).then((res) => {
        this.list = res.content;
        this.totalCount = res.totalCount;
      });
    },
    changeType(item, index) {
      this.current = index;
      this.contentType = item.contentType;
      this.currentPage=1;
      this.getList();
    },
    search() {
      this.getList();
    },
    // 添加封面图
    add(row) {
      this.visible = true;
      this.addList = row;
      // this.addBanner();
      // if (this.$route.query.obj.needCoverImg == 1) {
      //   this.visible = true;
      // } else {
      //   this.coverImg = "";
      //   this.addList = row;
      // }
    },
    addBanner(row) {
      this.postAxios("/rotation/insert", {
        contentType: this.contentType,
        contentId: this.addList.contentId,
        location: this.location,
        coverImg: this.coverImg,
        rank: this.rank,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.coverImg = "";
          this.rank = "";
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    // 封面图上传成功
    upSuccess(file) {
      this.coverImg = file.entity;
    },
    hideModal() {
      this.visible = false;
      this.addBanner();
    },
    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //分页：
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getList();
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
  mounted() {
    this.location = this.AddData.location;
    this.getList();
  },
  watch: {
    AddData(newVal, oldVal) {
      this.activeKey = 0;
      this.currentPage = 1;
      this.contentType = 1;
      this.location = newVal.location;
      this.getList();
    },
  },
};
</script>
<style scoped lang="less">
.active {
  background: #409eff;
  color: #fff;
}
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 150px;
  height: 150px;
  text-align: center;
  line-height: 145px;
  float: left;
  margin-left: 15px;
}
/deep/ .ant-tabs-bar {
  margin: 0 !important;
}
</style>